import {ID} from '../../../_metronic/helpers'
import {THistory, TCreditCardRefund} from '../../../coreGlobal/models/billing'

export type Billing = {
  id: ID
  amount: number
  status: string
  createdAt: string
  updatedAt: string
  paymentOption: PaymentOption
  numberOfInstallments: number
  installments: Array<Installments>
  recurrencePayment: RecurrencePayment
  recurrenceInstallment: InstallmentsRecurrence
  settledInstallment?: Installments
  creditCardPayments: Array<creditCardPayments>
  history: THistory[]
  creditCardRefunds?: TCreditCardRefund[]
}

export type RecurrencePayment = {
  amount: string
  attemptsFailed: number
  attemptsSuccessful: number
  createdAt: string
  creditCard: CreditCard
  currency: string
  endDate: string
  id: number
  installments: Array<InstallmentsRecurrence>
  nextPaymentDate: string
  startDate: string
  status: string
  updatedAt: string
}

interface CreditCard {
  id: number
  holderName: string
  holderDocument: string
  firstNumbers: string
  lastNumbers: string
  expirationMonth: string
  expirationYear: string
  token?: string
  brand?: {
    id: number
    description: string
  }
  createdAt: string
  updatedAt: string
}

export type TBillingInstallment = {
  id: number
  amount: string
  dueDate: string
  installment: number
  installmentsNumber: number
  status: string
  updatedAt: string
  createdAt: string
}

export type creditCardPaymentResponse = {
  creditCard: CreditCardResponse
  Tid: string
}
type CreditCardResponse = {
  CardNumber: string
  Holder: string
  ExpirationDate: string
  Brand: string
  PaymentAccountReference: string
}

export type Address = {
  id: ID
  city: {
    id: ID
    name: string
  }
  complement: string
  main: boolean
  neighborhood: string
  number: string
  street: string
  zipCode: string
}

export type PaymentOption = {
  id: ID
  name: string
  active: boolean
  installmentEnabled: boolean
  categoryId?: number
  franchise: Franchise
  category: CategoryRecurence
  createdAt: Date
  updatedAt: Date
}

type CategoryRecurence = {
  id: number
  name: string
}

type Franchise = {
  id?: ID
  name?: string
  type?: string
  createdAt?: Date
  updatedAt?: Date
  person?: {
    juridicalPerson?: {
      cnpj?: string
      cnpjWithoutMask?: string
    }
  }
}
export type InstallmentsRecurrence = {
  id: ID
  installmentsNumber: number
  next_attempt_date: string
  amount: number
  dueDate: string
  paidAt: string
  status: {
    id: number
    name: string
    i18n: string
    color: string
  }
  creditCardPayments: Array<creditCardPayments>
  settledBilling?: Billing
  createdAt: Date
  updatedAt: Date
}

type creditCardPayments = {
  id: number
  amount: string
  installments: number
  paymentId: string
  returnCode: string
  status: string
  createdAt: string
  updatedAt: string
  creditCard: CreditCard
}

export type Installments = {
  id: ID
  installment: number
  amount: number
  dueDate: string
  statusId: number
  status: string
  i18nStatus: string
  paidBy: number
  paidAt: Date
  settledBillingId?: number | null
  settledBilling?: Billing
  createdAt: Date
  updatedAt: Date
}
export const IContract: FileRequest = {
  file: ``,
  directory: ``,
}
export type FileRequest = {
  file: any
  directory: string
}
